/*
  Pacem "Join the list": sends the footer signup to Klaviyo instead of Shopify's
  customer form (client call, 2026-09-30). The markup and styling stay the
  section's own; this only takes over the submit.

  Posts to Klaviyo's client subscriptions API with the store's public company id,
  which subscribes the email to the list (and so starts the list's welcome flow).
  Without JavaScript the form still posts to Shopify's customer form.
*/
(() => {
  const ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  const REVISION = '2026-07-15';

  const init = (root) => {
    if (root.dataset.pjlBound) return;
    root.dataset.pjlBound = 'true';

    const { companyId, listId, source, successMessage, errorMessage } = root.dataset;
    const form = root.querySelector('form');
    if (!form || !companyId || !listId) return;

    const message = form.querySelector('[data-pjl-message]');
    const button = form.querySelector('button[type="submit"]');
    const field = (name) => {
      const input = form.querySelector(`[name="contact[${name}]"]`);
      return input ? input.value.trim() : '';
    };

    const show = (text, isError) => {
      // Clear any message left from a no-JS post to the customer form.
      form.querySelectorAll('.pjl__message:not([data-pjl-message])').forEach((el) => el.remove());
      message.textContent = text;
      message.classList.toggle('pjl__message--error', isError);
      message.setAttribute('role', isError ? 'alert' : 'status');
      message.hidden = false;
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;

      const email = field('email');
      const attributes = { email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
      if (field('first_name')) attributes.first_name = field('first_name');
      if (field('last_name')) attributes.last_name = field('last_name');

      button.disabled = true;
      form.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(`${ENDPOINT}?company_id=${encodeURIComponent(companyId)}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: { custom_source: source || 'Footer Sign Up', profile: { data: { type: 'profile', attributes } } },
              relationships: { list: { data: { type: 'list', id: listId } } },
            },
          }),
        });
        if (!response.ok) throw new Error(`Klaviyo ${response.status}`);

        // Tie this browser to the profile, so Klaviyo's popup treats them as subscribed.
        if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
          window.klaviyo.identify({ email });
        }
        form.reset();
        // Fade the form out and show the larger thank-you in its place
        // (client, 2026-10-08). Falls back to the small message if the
        // section markup predates the thank-you panel.
        const thanks = root.querySelector('[data-pjl-thanks]');
        if (thanks) {
          message.hidden = true;
          thanks.textContent = successMessage;
          root.classList.add('pjl--done');
          setTimeout(() => thanks.focus({ preventScroll: true }), 400);
        } else {
          show(successMessage, false);
        }
      } catch (error) {
        show(errorMessage, true);
      } finally {
        button.disabled = false;
        form.removeAttribute('aria-busy');
      }
    });
  };

  const bindAll = () => document.querySelectorAll('[data-pjl-klaviyo]').forEach(init);
  bindAll();
  // Re-bind when the theme editor re-renders the section.
  document.addEventListener('shopify:section:load', bindAll);
})();
